import React from "react";
import PropTypes from "prop-types";
import StyledShopBreadCrumbBundle from "./ShopBreadCrumbBundle.styled";
import SVGIcon from "../utility/SVGIcon";

const ShopBreadCrumbBundle = React.memo((props) => {
    const {name, clearAll, count, selectType, checkFilter, disabled, uri_param} = props;
    return (
      <StyledShopBreadCrumbBundle
          disabled={count === 0 || disabled}
          className="t-font-artifex t-font-DINNextLTPro-Regular"
          onClick={
            () => {
                if(clearAll)
                {
                    return clearAll()
                } else {
                    return checkFilter(uri_param, selectType, name)
                }
            }}
      >
          {!clearAll && <SVGIcon name="close" width="8"/>}
          {clearAll && <span>{name} {`(${count})`}</span>}
          {!clearAll && <span>{name}</span>}
      </StyledShopBreadCrumbBundle>
    );
});

ShopBreadCrumbBundle.propTypes = {
    name: PropTypes.string,
    clearAll: PropTypes.func,
    disabled: PropTypes.bool,
    count: PropTypes.number,
    key: PropTypes.string,
    id: PropTypes.string,
    uri_param: PropTypes.string,
    selectType: PropTypes.string,
    checkFilter: PropTypes.func,
    checkFilterPrice: PropTypes.func,
};

export default ShopBreadCrumbBundle;
